// Paridad diaria de `fetchNominacionesCrudas.ts` (Tarea 17): el reporte "Reconocimiento Diario" no
// tiene campaña — pagina `recognitionApi.exportRaw` por RANGO DE FECHAS en vez de por `campaignId`.
// Mismo lote y misma condición de corte que las hojas de Brillamos Juntos.
//
// 2026-10-19 — sin el tope de 5000 filas: «Todos los reconocimientos» del Diario lleva el periodo
// completo, igual que Brillamos Juntos desde RPT-6.
import { recognitionApi } from '@/api/recognition';
import type { NominationRawExportRowDto } from '@/api/recognition';
import { recorrerTodasLasPaginas } from './fetchNominacionesCrudas';

const LOTE_RECONOCIMIENTOS_CRUDOS = 200;

/**
 * Pagina `recognitionApi.exportRaw` completo para el rango `[from, to]`, hasta la primera página
 * vacía (ver `recorrerTodasLasPaginas`). NO atrapa errores de red/HTTP: el llamador (`DailyTab.tsx`)
 * decide cómo mostrarlos.
 */
export function fetchRecognitionsCrudoPaginado(from: string, to: string): Promise<NominationRawExportRowDto[]> {
  return recorrerTodasLasPaginas(
    (pagina) => recognitionApi.exportRaw(from, to, pagina, LOTE_RECONOCIMIENTOS_CRUDOS),
  );
}
